import { forwardRef, Provider } from '@angular/core';
import { PhotoUploadService } from '../components/camera/camera/photo-upload.service';
import { FileUploadService } from '../components/file-upload/file-upload.service';
import { CdkModalService } from './cdk-modal.service';
import { CookieService } from './cookie.service';
import { CustomModalService } from './custom-modal.service';
import { S3PhotoUploadService } from './s3-photo-upload.service';
import { S3UploadMockService } from './s3-upload-mock.service';
import { S3UploadService } from './s3-upload.service';
import { AppToastrService } from './toastr.service';
import {AppInitService} from './app-init.service';
import {AuthService} from './auth.service';
import {SessionStorageService} from './session-storage.service';
import { SpinnerService } from '@ui-app/components/spinner/spinner.service';
import { ResponsiveService } from './responsive.service';
import {S3DeleteService} from './s3-delete.service';
import { ImageService } from '@ui-app/services/image.service';

export const SharedServices: Provider[] = [
    CdkModalService,
    CustomModalService,
    AppToastrService,
    S3UploadService,
    S3DeleteService,
    {
        provide: FileUploadService,
        /**
         * S3UploadService used as default upload service
         * any service with FileUploadService signature can be provided in place of usage
         */
        useExisting: forwardRef(() => S3UploadService),
    },
    S3UploadMockService,
    CookieService,
    AuthService,
    SessionStorageService,
    S3PhotoUploadService,
    {
        provide: PhotoUploadService,
        /**
         * S3PhotoUploadService used as default upload service
         * any service with PhotoUploadService signature can be provided in place of usage
         */
        useExisting: forwardRef(() => S3PhotoUploadService),
    },
    SpinnerService,
    ResponsiveService,
    ImageService
];
